module.exports = __webpack_public_path__ + "71b4d74ab444bc073048f581262ff1f0.pdf";